import { render, staticRenderFns } from "./CardElementCreateCommentAction.vue?vue&type=template&id=0a710a8d"
import script from "./CardElementCreateCommentAction.vue?vue&type=script&lang=js"
export * from "./CardElementCreateCommentAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports